module.exports = __webpack_public_path__ + "img/3-1.7d2793e4.png";